import { FlexibleModelBase, FlexibleBaseSpecification } from './flexible_base';
import type { OpenUrlWithKind } from '@api/generated/models';

interface Icon {
	origin: string;
	type: 'svgUrl' | 'pngUrl' | 'local';
}

export interface FlexibleActionCardSpecification extends FlexibleBaseSpecification {
	id: number;
	title: string;
	url: string;
	requiresAuthentication: boolean;
	openAnotherApp: boolean;
	hasBrandedNavbar: boolean;
	icon: Icon | null;
	subtitle: string;
	openUrlWith: OpenUrlWithKind;
}

/**
 * NOTE: ActionCard is not a part of the backend spec. We're intentionally
 * defining it on the frontend.
 */
export class FlexibleActionCardModel extends FlexibleModelBase {
	public readonly title: string;
	public readonly url: string;
	public readonly requiresAuthentication: boolean;
	public readonly openAnotherApp: boolean;
	public readonly hasBrandedNavbar: boolean;
	public readonly icon: Icon | null;
	public readonly subtitle: string;
	public readonly openUrlWith: OpenUrlWithKind;

	constructor(spec: FlexibleActionCardSpecification) {
		super(spec);

		this.title = spec.title;
		this.url = spec.url;
		this.requiresAuthentication = spec.requiresAuthentication;
		this.openAnotherApp = spec.openAnotherApp;
		this.hasBrandedNavbar = spec.hasBrandedNavbar;
		this.icon = spec.icon;
		this.subtitle = spec.subtitle;
		this.openUrlWith = spec.openUrlWith;
	}
}
